import React from "react";
import { Handle, Position } from "@xyflow/react";
import { FaCommentDots } from "react-icons/fa";

export default function WaitForReplyNode({ data, selected }) {
  const value = Number(data?.timeoutValue);
  const unit = data?.timeoutUnit || "hours";
  const legacy = Number(data?.timeoutHours);
  const timeoutLabel = Number.isFinite(value) && value > 0
    ? `${value} ${unit}`
    : Number.isFinite(legacy) && legacy > 0
      ? `${legacy} hours`
      : "24 hours";

  return (
    <div
      className={`rounded-xl border-2 bg-surface-card shadow-sm min-w-[200px] transition-shadow ${
        selected ? "border-orange-500 shadow-md" : "border-surface-border"
      }`}
    >
      {/* Input handle */}
      <Handle
        type="target"
        position={Position.Top}
        className="!w-3 !h-3 !bg-orange-500 !border-2 !border-white"
      />

      {/* Header */}
      <div className="flex items-center gap-2 px-3 py-2 rounded-t-[10px] bg-orange-500">
        <FaCommentDots size={11} className="text-white" />
        <span className="text-xs font-semibold text-white">Wait for Reply</span>
      </div>

      {/* Body */}
      <div className="px-3 py-2.5 text-center space-y-1">
        <p className="text-xs text-ink-muted">Pauses until user replies</p>
        <p className="text-[10px] text-ink-muted">Timeout: {timeoutLabel}</p>
      </div>

      {/* Branch labels */}
      <div className="flex justify-between px-3 pb-2 text-[10px] text-ink-muted">
        <span>Replied</span>
        <span>Timeout</span>
      </div>

      {/* Output handles — "replied" (bottom-left), "timeout" (bottom-right) */}
      <Handle
        id="replied"
        type="source"
        position={Position.Bottom}
        style={{ left: "25%" }}
        className="!w-3 !h-3 !bg-orange-500 !border-2 !border-white"
      />
      <Handle
        id="timeout"
        type="source"
        position={Position.Bottom}
        style={{ left: "75%" }}
        className="!w-3 !h-3 !bg-amber-600 !border-2 !border-white"
      />
    </div>
  );
}
